<template>

  <header class="nav-head">
<!--    <div class="lodingClass" v-if="lodingPage"></div>-->
    <div class="top-nav">
      <div class="logo">
        <router-link :to="dashboardLink"
        ><img
          :src="require('@/assets/images/CleverStaff_head_logo.svg')"
          width="193"
          alt="Logo"
        />
        </router-link>
      </div>
      <div class="right-nav">
        <ul class=" right-nav-links" v-if="user.is_leave_access==1 && user.managerAccess=='yes'">
          <li class="nav-item dropdown">
            <a
              class="nav-link down-arrow"
              href="javascript:void(0)"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="ico ico-setting"></i>
              <span class="d-none d-lg-inline-block">Settings</span>
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <logout :className="'dropdown-item orange'"></logout>
            </div>
          </li>
        </ul>
        <ul class=" right-nav-links" v-else>
<!--          <li v-if="isRouteAccess">
            <button class="btn btn-sm btn-success btn-update mr-10" v-if="isPartner" >
              You are partner
            </button>
            <button class="btn btn-sm btn-primary btn-update mr-10" v-else @click="becomePartner">
              Become a Partner
            </button>
          </li>-->
          <li v-if="companyMembership.membership && isRouteAccess" >
            <router-link :to="{ name: 'upgrade-plan' }" class="btn btn-sm btn-success btn-update"
                         v-if="companyMembership.payment==null">
              <span
                v-if="companyMembership.is_trial=='1'">{{ companyMembership.membership.name }} Plan - Free Trial</span>
              <span v-else>{{ companyMembership.membership.name }} Plan</span>
            </router-link>
            <button class="btn btn-sm btn-success btn-update" v-else>
              <span
                v-if="companyMembership.is_trial=='1'">{{ companyMembership.membership.name }} Plan - Free Trial</span>
              <span v-else>{{ companyMembership.membership.name }} Plan</span>
            </button>
          </li>
          <li v-else>
            <div v-if="isRouteAccess">
            <router-link class="btn btn-sm btn-danger btn-update" v-if="isReferBY" to=""  >
              Upgrade
            </router-link>
            <router-link class="btn btn-sm btn-danger btn-update" v-else :to="{ name: 'upgrade-plan' }">
              Upgrade
            </router-link>
          </div>
          </li>
          <li class="nav-item dropdown notifications-drop-wrp"  v-if="isRouteAccess">
            <a
              class="notification-link"
              href="javascript:void(0)"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="ico ico-bell"></i>
              <span class="count">{{ notifiLength.length }}</span>
            </a>
            <div class="dropdown-menu notifications-drop">
              <div class="notifications-drop-head">
                <span class="title">Notifications</span>
                <a href="javascript:void(0)" class="close"><i class="ico-cross"></i></a>
              </div>
              <ul>
                <li v-for="(log,key) in notificationLogs" :key="key" :class="{unread:log.is_read === 0}" v-if="log.body">
                  <a href="javascript:void(0);" @click="readTheNotification(log.id)">
                    <i class="ico ico-fill-circle"></i>
                    <span class="text"> {{ log.body }}</span>
                    <span class="date">{{ log.created_at | moment('MMMM D, Y HH:mm') }}</span>
                  </a>
                </li>
                <li v-for="(log,key) in allEventsLogs" :key="key" :class="{unread:log.is_read === 0}" v-if="log.body">
                  <a href="javascript:void(0);" @click="readTheNotification(log.id)">
                    <i class="ico ico-fill-circle"></i>
                    <span class="text"> {{ log.body }}</span>
                    <span class="date">{{ log.created_at | moment('MMMM D, Y HH:mm') }}</span>
                  </a>
                </li>

              </ul>
            </div>
          </li>
          <li class="nav-item dropdown" v-if="user && isRouteAccess">
    <a
        class="nav-link down-arrow"
        href="javascript:void(0)"
        id="navbarDropdown1"
        role="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
    >
        <img
            :src="require('@/assets/images/building.svg')"
            class="icon-building"
            alt="building"
        />
        <span class="d-none d-lg-inline-block text-capitalize">
            {{
                $getSafe(
                    () =>
                        $store.state.user.companies.find(x => x.is_selected == 1).name
                )
            }}
        </span>
    </a>
<!--    <div class="dropdown-menu" aria-labelledby="navbarDropdown1" v-if="$store.state.user.id !='1528'">-->
    <div class="dropdown-menu" aria-labelledby="navbarDropdown1">

        <button class="dropdown-item" type="button"
                @click="changeUserSelectedComp(company.id)" v-for="company in $store.state.user.companies">
            {{ company.name }}
        </button>
        <router-link :to="{ path: '/my-companies' }">
            <a class="dropdown-item orange">My Companies</a>
        </router-link>
    </div>
</li>

    <li class="nav-item" v-else>
        <a
            class="nav-link"
            href="javascript:void(0)"
            id="navbarDropdown1"
            role="button"
        >
            <img
                :src="require('@/assets/images/building.svg')"
                class="icon-building"
                alt="building"
            />
            <span class="d-none d-lg-inline-block text-capitalize">
                {{ $getSafe(() => $store.state.user.companies.find(x => x.is_selected == 1).name) }}
            </span>
        </a>
    </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link down-arrow"
              href="javascript:void(0)"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="ico ico-setting"></i>
              <span class="d-none d-lg-inline-block">Settings</span>
            </a>

            <div class="dropdown-menu" aria-labelledby="navbarDropdown">

              <router-link to="/tax-slabs" class="dropdown-item" v-if="isRouteAccess">Tax Slabs</router-link>
              <router-link class="dropdown-item" to="/requests" v-if="isRouteAccess">Requests</router-link>
              <router-link to="/settings/general" class="dropdown-item" v-if="isRouteAccess" ><span
                class="d-none d-lg-inline-block text-capitalize">{{
                  $getSafe(
                    () =>
                      $store.state.user.companies.find(x => x.is_selected == 1)
                        .name
                  )
                }}</span> Settings
              </router-link>
              <logout :className="'dropdown-item orange'"></logout>
            </div>
          </li>
          <li class="nav-item d-block d-lg-none">
            <button
              class="navbar-toggler"
              id="exCollapsingNavbar"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="navbar-toggler-icon"></span>
              <span></span>
              <span></span>
              <span></span>
            </button>
          </li>
        </ul>
      </div>
    </div>

    <nav class="navbar-second navbar-expand-lg  ">
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav nav-right-links" v-if="user.is_leave_access==1 && user.managerAccess=='yes'">
          <li class="nav-item" v-bind:class="leave_nav && 'active'" @click="activeCompo">
            <router-link :to="{name:'leaves'}" class="nav-link">leaves</router-link>
          </li>
        </ul>
        <ul class="navbar-nav nav-right-links" v-else>
          <li
            class="nav-item"
            v-bind:class="dashboard && 'active'"
            @click="activeCompo"
            v-if="isRouteAccess"
          >
            <router-link :to="{ name: 'dashboard' }" v-bind:class="{ 'disabledClass' : companyStatusDisabled == true}"  >
              <span class="nav-link"
              >Schedules <span class="sr-only">(current)</span></span
              >
            </router-link>
          </li>
          <li
            class="nav-item"
            v-bind:class="employee && 'active'"
            @click="activeCompo"
            v-if="isRouteAccess"
          >
            <router-link :to="{ name: 'employees' }" v-bind:class="{ 'disabledClass' : companyStatusDisabled == true}" >
              <span class="nav-link">Employees  </span>
            </router-link>
          </li>
          <li class="nav-item" v-bind:class="messages_nav && 'active'" @click="activeCompo" v-if="isRouteAccess" >
            <router-link to="/messages/inbox" class="nav-link" v-bind:class="{ 'disabledClass' : companyStatusDisabled == true}" > messages</router-link>
          </li>
<!--          <li class="nav-item" v-bind:class="leave_nav && 'active'" @click="activeCompo">
            <router-link :to="{name:'leaves'}" class="nav-link">leaves</router-link>
          </li>-->
          <li class="nav-item" v-bind:class="leave_nav && 'active'" @click="activeCompo" v-if="isRouteAccess">
            <span class="nav-link" v-bind:class="{ 'disabledClass' : companyStatusDisabled == true}"  >Leaves</span>
            <ul class="drop">

              <li v-bind:class="{ 'disabledClass' : companyStatusDisabled == true}">
                <router-link to="/settings/leaves">leave Types</router-link>
              </li>
              <li v-bind:class="{ 'disabledClass' : companyStatusDisabled == true}">
                <router-link :to="{name:'leaves'}">Leaves</router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item" v-bind:class="salary_calc_nav && 'active'" @click="activeCompo" v-if="isRouteAccess">
            <router-link :to="{ path: '/salary-calculator' }" v-bind:class="{ 'disabledClass' : companyStatusDisabled == true}" >
              <span class="nav-link">Hours & Salary</span>
            </router-link>
          </li>
          <li class="nav-item" v-bind:class="profile_nav && 'active'" @click="activeCompo">
             <a :href="$router.resolve({path: '/employee/profile/'+uuid+''}).href" v-bind:class="{ 'disabledClass' : companyStatusDisabled == true}" ><span
              class="nav-link">My Profile </span></a>
          </li>

          <li class="nav-item" v-bind:class="comp_profile_nav && 'active'" @click="activeCompo" v-if="isRouteAccess">
            <router-link :to="{name: 'company-profile'}" v-bind:class="{ 'disabledClass' : companyStatusDisabled == true}"  >
              <span class="nav-link">company profile </span>
            </router-link>
          </li>
          <li class="nav-item" v-bind:class="reports_nav && 'active'" @click="activeCompo" v-if="isRouteAccess">
            <span class="nav-link" v-bind:class="{ 'disabledClass' : companyStatusDisabled == true}" >Reports</span>
            <ul class="drop">

              <li v-bind:class="{ 'disabledClass' : companyStatusDisabled == true}">
                <router-link :to="{name:'reports-attendance'}">Attendance</router-link>
              </li>
              <li v-bind:class="{ 'disabledClass' : companyStatusDisabled == true}">
                <router-link :to="{name:'reports-attendance-progress'}">Attendance Progress</router-link>
              </li>
              <li v-bind:class="{ 'disabledClass' : companyStatusDisabled == true}">
                <router-link :to="{name:'reports-attendance-maps'}">Attendance Maps</router-link>
              </li>
            </ul>
          </li>
          <!-- Attendance page -->
            <li class="nav-item" v-bind:class="attendance_punchin && 'active'" @click="activeCompo" v-if="user && user.type=='EMPLOYEE'">
              <router-link :to="{ path: '/attendance/punchin'}" v-bind:class="{ 'disabledClass': companyStatusDisabled==true }">
                <span class="nav-link">Attendance</span>
              </router-link>
            </li>


          <li class="nav-item" v-bind:class="timesheet_nav && 'active'" @click="activeCompo">
            <span class="nav-link" v-bind:class="{ 'disabledClass' : companyStatusDisabled == true}" >Time Sheet</span>
            <ul class="drop">
              <li v-bind:class="{ 'disabledClass' : companyStatusDisabled == true}" v-if="isRouteAccess">
                <router-link :to="{name:'timesheet-customers'}">Customers</router-link>
              </li>
              <li v-bind:class="{ 'disabledClass' : companyStatusDisabled == true}" v-if="isRouteAccess">
                <router-link :to="{name:'timesheetProjects'}">Projects</router-link>
              </li>
              <li v-bind:class="{ 'disabledClass' : companyStatusDisabled == true}" v-if="isRouteAccess">
                <router-link :to="{name:'timesheets'}">TimeSheets</router-link>
              </li>
              <li v-bind:class="{ 'disabledClass' : companyStatusDisabled == true}" v-else>
                <router-link :to="{path:'/timesheet/add/'+user.uuid}">My Timesheets</router-link>
              </li>
            </ul>
          </li>
<!--          <li class="nav-item" v-bind:class="partner_features && 'active'" v-if="isPartner && isRouteAccess" @click="activeCompo">
            <span class="nav-link" v-bind:class="{ 'disabledClass' : companyStatusDisabled == true}" >Partner Features</span>
            <ul class="drop">
              <li v-bind:class="{ 'disabledClass' : companyStatusDisabled == true}">
                <router-link :to="{name:'partnerProductItems'}">Product items</router-link>
              </li>
              <li v-bind:class="{ 'disabledClass' : companyStatusDisabled == true}">
                <router-link :to="{name:'partnerTransactions'}">Transactions</router-link>
              </li>
            </ul>
          </li>-->
          <!--         <li class="nav-item upgrad-memb" v-bind:class="upgrade_membership && 'active'" @click="activeCompo">-->
          <!--            <router-link :to="{name: 'upgrade-membership'}" class="nav-link">Upgrade Membership</router-link>-->
          <!--          </li>-->
        </ul>
      </div>
    </nav>
<!--    become partner modal-->
    <div
      class="modal fade write-msg-model send-invitation-model"
      id="invite-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="write-msg-modelLabel"
      aria-hidden="true"
      :class="{'show':inviteModel===true}"
    >
      <div class="modal-dialog modal-sm modal-dialog-scrollable modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title">
              <h5>Become a partner </h5>
              <p class="gray-text">please select .</p>
            </div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="clearInviteReq"
            >
              <span class="ico-cross"></span>
            </button>
          </div>
          <div class="modal-body">
           <ul class="list-unstyled">
             <li class="mb-15 " v-for="benefitCategory in benefitCategories">
               <input type="checkbox" v-model="benefitFrom.benefitCategoryIds" :value="benefitCategory.id" > <span class="text-capitalize">{{ benefitCategory.name }}</span>
<!--               <br>
               <textarea class="form-control text-capitalize" v-model="benefitFrom.benefitCategoryDescription[benefitCategory.id]" :placeholder="benefitCategory.name +' Description'"></textarea>-->
             </li>
           </ul>
          </div>
          <div class="modal-footer ">
            <button class="btn btn-outline-primary " @click="submitPartnerRequest">Submit</button>

          </div>

        </div>
      </div>
    </div>
    <!--model when company temporary -->
    <div class="" v-if="isTemporaryBlock">
      <div id="myModalTemporaryBlock" class="show modal fade myModalTemporaryBlock" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal"></button>
              <h4 class="modal-title align-left"></h4>
            </div>
            <div class="modal-body">
              <h2>Your account has been deactivated temporarily. You may contact support@cleverstaff.com for reactivating your account.</h2>
            </div>
            <div class="modal-footer">

            </div>
          </div>

        </div>
      </div>

    </div>
    <div v-if="isCardDetail">
      <div id="myModalStripeCardDetail" class="show modal fade myModalTemporaryBlock" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal"></button>
              <h4 class="modal-title align-left">Card Detail</h4>
            </div>
            <div class="modal-body">
<!--              <stripe-card></stripe-card>-->
            </div>
            <div class="modal-footer">

            </div>
          </div>

        </div>
      </div>
    </div>

  </header>

</template>

<script>
import moment from 'moment'
import logout from "../Settings/Partials/logout";
import axios from "axios";
import Swal from "sweetalert2";
import Echo from 'laravel-echo';
window.io = require("socket.io-client");
// import stripeCard from "../Membership/stripeCard";
export default {
  name: "Header",
  components: {
    logout,
    // stripeCard
  },
  data() {
    return {
      benefitFrom:{
        company_id:'',
        benefitCategoryIds: [],
        benefitCategoryDescription: [],
      },
      isRouteAccess: false,
      allEventsLogs: [],
      notificationLogs: [],
      companyStatusDisabled: false,
      isTemporaryBlock: false,
      isCardDetail: false,
      dashboard: false,
      lodingPage: true,
      employee: false,
      profile_nav: false,
      company_profile: false,
      salary_calc_nav: false,
      comp_profile_nav: false,
      attendance_punchin:false,
      reports_nav: false,
      timesheet_nav: false,
      partner_features: false,
      upgrade_membership: false,
      leave_nav: false,
      messages_nav: false,
      user: (this.$store.getters.getUser) ? this.$store.getters.getUser : '',
      user_id: (this.$store.getters.getUser) ? this.$store.getters.getUser.id : '',
      uuid: (this.$store.getters.getUser) ? this.$store.getters.getUser.uuid : '',
      company: this.$store.getters.getSelectedCompany,
      company_id: this.$store.getters.getSelectedCompany.id,
      companyMembership: {},
      companyPartner: {},
      isPartner: false,
      isReferBY: false,
      inviteModel: false,
      notifiLength: [],
      benefitCategories: []
    };
  },
  computed: {
    dashboardLink() {
      const user = this.$store.getters.getUser;
      // Check user type and return the appropriate path
      return user && user.type === 'EMPLOYEE'
        ? { name: 'attendance/punchin' }
        : { name: 'dashboard' };
    },
  },
  created() {
    this.isRouteAccess=this.routeAndPageAccess(this.$store.getters.getLoginInProfile);
    this.getCompany();
    this.getCompanyMembership();
    // this.getCompanyPartner();
    // this.getCompanyMembership();
    // this.getBenefitCategories();
    this.activeCompo();
    this.getallEventsLogs();
    if(this.user && (this.user.type=='MANAGER' || (this.user.type=='EMPLOYEE' && this.user.managerAccess=='yes'))) {
      this.setupEcho();
    }
    // this.getLogs();
    if (JSON.parse(localStorage.getItem('user')) == null && localStorage.getItem('isLogin') == 1) {
      this.logout();
    }
    if(this.user.refer_by =='ptcl' || this.$store.getters.getSelectedCompany.partner_customer_no !=null){
      this.isReferBY=true
    }
   /* if (localStorage.getItem('isLogin') == 1) {
      const recaptchaScript = document.createElement("script");
      recaptchaScript.setAttribute(
        "src",
        "https://js-na1.hs-scripts.com/23315391.js"
      );
      document.head.appendChild(recaptchaScript);
    }*/

    this.$root.$on("activeCompoClick", () => {
      this.activeCompo();
    });
  },

  methods: {
    getCompany() {
      this.id = this.$store.getters.getSelectedCompany.id;
      this.$axios.get(this.$GetCompany.replace(":id", this.id), {
        headers: this.getAuthHeader(),
      }).then((response) => {
        if( response.data.result.company.status===0){
          this.isTemporaryBlock=true;
          this.companyStatusDisabled=true;
          $('#myModalTemporaryBlock').modal({backdrop: 'static', keyboard: false}).modal('show');
        }/*else if(response.data.result.company.country !="Pakistan" && (response.data.result.company.paymentMethod =='' || response.data.result.company.paymentMethod ==null ) ){

          this.isCardDetail=true;
           $('#myModalStripeCardDetail').modal({backdrop: 'static', keyboard: false}).modal('show');
        }*/
      })
    },
    clearInviteReq() {
      this.inviteModel =false;
    },
    submitPartnerRequest(){
     // return 1;
      this.benefitFrom.company_id=this.company_id;
      axios.post(this.$Partners,this.benefitFrom, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.data.status === 200) {
            if(res.data.result){
              if(this.isReferBY==false){

                this.isPartner=true;
              }
            }
            this.inviteModel =false;
            $root.$toast.success(res.data.message);
          }else{
            new Swal({
              title: "Please select!",
              icon: "warning",
              text: "Please select at least one benefit category",
              type: "warning",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Ok"
            })
          }
        });
    },
    becomePartner(){
      this.inviteModel=true;
    },
    getCompanyPartner() {
      let params = {
        company_id: this.company_id,
      };
      this.$axios
        .get(this.$Partners, {
          params: params,
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          this.companyPartner = response.data.result || [];
          if(this.companyPartner.is_partner==1){
            if(this.isReferBY==false){

              this.isPartner=true;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getBenefitCategories() {
      this.$axios
        .get(this.$benefitCategories, {
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          this.benefitCategories = response.data.result || [];
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getCompanyMembership() {
      let params = {
        company_id: this.company_id,
      };
      this.$axios
        .get(this.$CompanyMembership, {
          params: params,
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          this.companyMembership = response.data.result || [];
        })
        .catch((error) => {
          console.log(error);
        });
    },

    readTheNotification(id) {
      this.$axios({
        method: "post",
        data: {
          id: id,
        },
        url: this.$ReadTheNotification,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          this.$router.push({name: "requests"});
          this.getallEventsLogs();
        }
      });
    },
    setupEcho() {
      if (typeof io !== "undefined") {
        window.Echo = new Echo({
          broadcaster: "socket.io",
          host: process.env.SOCKET_URL,
        });

         window.Echo.channel('cleverStaff')
        .listen('editRequest', (res) => {
            this.allEventsLogs.unshift(res.data);
            this.notifiLength = this.allEventsLogs.filter(item => item.is_read === 0);
        });
      }
    },
    getallEventsLogs() {
      this.$axios({
        method: "get",
        params: {
          company_id: this.$store.getters.getSelectedCompany.id,
        },
        url: this.$allRequestLogs,
        headers: this.getAuthHeader()
      }).then(res => {
        if (res.status == 200) {
          this.allEventsLogs = res.data.result.data;
          this.notifiLength = this.allEventsLogs.filter(item => item.is_read === 0);
        }
      });
    },
    getLogs() {
      this.$axios({
        method: "get",
        params: {
          company_id: this.$store.getters.getSelectedCompany.id,
        },
        url: this.$Logs,
        headers: this.getAuthHeader()
      }).then(res => {
        if (res.status === 200) {
          this.notificationLogs = res.data.result;
          this.notifiLength = this.notificationLogs.filter(item => item.is_read === 0);
          this.notificationLogs.sort((a, b) => a > b ? 1 : -1);
        }
      });
    },
    changeUserSelectedComp(id) {
      localStorage.setItem('companyEmployees', JSON.stringify(null));
      var currentPath = this.$route.path.replace("/", "");

      this.$axios({
        method: "get",
        params: {
          company_id: id,
          user_id: this.user_id
        },
        url: this.$ChangeSelectedComp,
        headers: this.getAuthHeader()
      }).then(res => {
        if (res.data.status == 200) {
          this.dashboard = true;
          this.employee = false;
          this.profile_nav = false;
          this.company_profile = false;
          this.salary_calc_na = false;
          this.comp_profile_nav = false;
          this.attendance_punchin=false;
          this.reports_nav = false;
          this.timesheet_nav = false;
          this.partner_features = false;
          this.upgrade_membership = false;
          this.leave_nav = false;
          this.$store.commit('setUser', res.data.result);
          if (currentPath == "dashboard") {
            this.$root.$emit('reloadDashboardOnChangeComp');
          }
          this.$router.push({name: 'dashboard'});
          //  this.$router.go(0);
        }
      });
    },
    activeCompo() {
      var currentPath = this.$route.path.replace("/", "");
      this.dashboard = currentPath == "dashboard" || currentPath == "schedule" ? true : false;
      this.salary_calc_nav = currentPath == "salary-list" || "salary-calculator" ? true : false;
      if (currentPath == "salary-list") {
        this.salary_calc_nav = true;
      } else if (currentPath == "salary-calculator") {
        this.salary_calc_nav = true;
      } else {
        this.salary_calc_nav = false;
      }
      this.comp_profile_nav = currentPath == "company-profile" ? true : false;
      this.attendance_punchin = currentPath == "attendance/punchin" ? true : false;
      this.reports_nav = currentPath == "reports/attendance" ? true : false;
      this.timesheet_nav = currentPath == "timesheets" || currentPath == "timesheet/customers" || currentPath == "timesheet/projects" ? true : false;
      this.leave_nav = currentPath == "leaves" ? true : false;
      this.partner_features = currentPath == "partner/product-items" || currentPath == "partner/transactions" ? true : false;
      this.messages_nav = currentPath == "messages/inbox" ? true : false;
      this.upgrade_membership = currentPath == "upgrade-membership" ? true : false;
      if (this.uuid == this.$route.params.id && this.$route.path.startsWith('/employee/profile')) {
        this.profile_nav = true;
        this.employee = false;
      } else {
        if (currentPath === "employees" || this.$route.path.startsWith('/employee/')) {
          this.employee = true;
        } else {
          this.employee = false;
        }
        this.profile_nav = false;
      }
      currentPath = '';
    },
    logout() {
      return this.$axios
        .get(this.$Logout, {
          headers: this.getAuthHeader()
        })
        .then(response => {
          localStorage.setItem('isLogin', 0);
          localStorage.setItem('companyEmployees', JSON.stringify(null));
          this.$store.commit("logoutUser");
          setTimeout(() => {
            this.$router.push({name: "login"});
          }, 2000)

        })
        .catch(error => {
          console.log(error);

        });
    }

  },


};
</script>
<style >
.disabledClass{
  pointer-events: none;
  opacity: 0.9;
}
.nav-head .navbar-second .nav-link {
  text-transform: capitalize !important;
}

.nav-head .dropdown-item {
  text-transform: capitalize !important;
}
.myModalTemporaryBlock{
  position: relative;
  z-index: 1;
  margin-top: 67px;
}
.top-nav{
  position: relative;
  z-index: 9999;
}
.myModalTemporaryBlock:before{
  content: "";
  position: absolute;
  left: 0;
  width: 100%;
  top: 0;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: -1;
}
.lodingClass{
  position: fixed;
  height: 100%;
  width: 100%;
  background: #f0f4f3;
  overflow: hidden;
  top: 0;
  z-index: 99999;
  left: 0;
}

</style>
